module.exports = __webpack_public_path__ + "img/mastercard.f5f372e8.svg";